import type { FC, SVGProps } from 'react';

export const KustomerLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 250 238"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_172_6215)">
      <path
        d="M125.784 238C21.6725 238 0.25 190.253 0.25 119.314C0.25 48.3757 20.6854 0 125.784 0C230.882 0 249.263 48.8171 249.263 120.197C249.263 191.577 229.895 238 125.784 238Z"
        fill="#FBEC2A"
      />
      <path
        d="M121.862 172.411C97.9454 172.411 78.4971 152.376 78.4971 127.754V103.292H89.1683V127.754C89.1683 146.478 103.841 161.712 121.862 161.712C139.883 161.712 154.556 146.478 154.556 127.754V103.292H165.228V127.754C165.228 152.376 145.779 172.411 121.862 172.411Z"
        fill="#292929"
      />
      <path
        d="M108.509 81.5312C106.668 76.9036 102.266 73.9211 97.3042 73.9211C92.3421 73.9211 87.9535 76.917 86.0994 81.5312L76.8154 77.7997C80.1902 69.347 88.2337 63.8768 97.3042 63.8768C106.375 63.8768 114.418 69.3336 117.793 77.7997L108.509 81.5312Z"
        fill="#292929"
      />
      <path
        d="M157.145 81.5312C155.291 76.9036 150.902 73.9211 145.94 73.9211C140.978 73.9211 136.589 76.917 134.735 81.5312L125.451 77.7997C128.826 69.347 136.869 63.8768 145.94 63.8768C155.011 63.8768 163.054 69.3336 166.429 77.7997L157.145 81.5312Z"
        fill="#292929"
      />
    </g>
    <defs>
      <clipPath id="clip0_172_6215">
        <rect
          width="249"
          height="238"
          fill="white"
          transform="translate(0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);
